export default __webpack_public_path__ + "static/media/mysteryBet.572e9cd6.png";